import DxDashboardNavbar from './DxDashboardNavbar.vue';
import DxRegulatorNavbar from './DxRegulatorNavbar.vue';
import DxAdminNavbar from './DxAdminNavbar.vue';

const setup = (app) => {
  app.component('dx-dashboard-navbar', DxDashboardNavbar);
  app.component('dx-regulator-navbar', DxRegulatorNavbar);
  app.component('dx-admin-navbar', DxAdminNavbar);
};

export default {
  setup,
};
